import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { colorVariantsSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { GiveawayMultipleProductsSelectionComponent } from './giveaway-multiple-products-selection';
const mapStateToProps = createStructuredSelector({
  colorVariants: colorVariantsSelector
});
export const GiveawayMultipleProductsSelection = connect(mapStateToProps)(GiveawayMultipleProductsSelectionComponent);